/* eslint-disable @angular-eslint/prefer-standalone */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from '@angular/core';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { LiteralsService } from '../../services/literals-service';

@Component({
  selector: 'tgv-empty-card-list',
  standalone: false,
  templateUrl: './empty-card-list.component.html'
})
export class EmptyCardListComponent {
  @Input() items: Array<any>;
  literals: LiteralsWords;

  constructor(private literalsService: LiteralsService) {
    this.literals = this.literalsService.getLiteralModule();
  }
}
